module.exports = __webpack_public_path__ + "static/media/zendesk_logo.08ba38da.png";